import React, { useState, useEffect } from 'react';
import './App.css';

function ReplaceForURL(url) {
    return url.replace(/[\s/!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~`]/g, "-");
}

function CalculateFields(answers, questions) {
    const categories = { STEM: 0, Humanities: 0, Business: 0, Trade: 0 };

    answers.forEach((selectedOptionText, i) => {
        const questionKey = Object.keys(questions[i])[0];
        const options = questions[i][questionKey];
        const value = options[selectedOptionText];

        if (typeof value === 'string') {
            const parts = value.split(',').map(part => part.trim());
            parts.forEach(part => {
                const match = part.match(/^(\+?\d+)\s+([A-Za-z]+)$/);
                if (match) {
                    const points = parseInt(match[1], 10);
                    const category = match[2];
                    if (categories.hasOwnProperty(category)) {
                        categories[category] += points;
                    }
                }
            });
        }
    });

    return Object.entries(categories)
        .sort((a, b) => b[1] - a[1])
        .map(([field]) => field);
}

function SupportedCareers() {
    const [careerSet, setCareerSet] = useState(new Set());

    useEffect(() => {
        const pathFiles = [
            'STEM_PATH.json',
            'BUSINESS_PATH.json',
            'TRADE_PATH.json',
            'HUMANITIES_PATH.json',
        ];

        const fetchCareers = async () => {
            const allCareers = new Set();

            for (const file of pathFiles) {
                try {
                    const res = await fetch(`/paths/${file}`);
                    const data = await res.json();

                    data.forEach(qObj => {
                        Object.values(qObj).forEach(options => {
                            Object.values(options).forEach(result => {
                                const isFollowUp = data.find(item => Object.keys(item)[0] === result);
                                if (typeof result === 'string' && !isFollowUp) {
                                    allCareers.add(result.trim());
                                }
                            });
                        });
                    });
                } catch (err) {
                    console.error(`Error loading ${file}:`, err);
                }
            }

            setCareerSet(allCareers);
        };

        fetchCareers();
    }, []);

    const careerList = Array.from(careerSet);

    return (
        <div>
            <h2>Number of Current Supported Careers Areas: {careerList.length}</h2>
        </div>
    );
}

function App() {
    const [questions, setQuestions] = useState([]);
    const [statistics, setStatistics] = useState({});
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showTitleScreen, setShowTitleScreen] = useState(true);
    const [fieldPathOptions, setFieldPathOptions] = useState([]);
    const [showFieldResult, setShowFieldResult] = useState(false);
    const [fieldPath, setFieldPath] = useState(null);
    const [pathQuestions, setPathQuestions] = useState([]);
    const [pathAnswers, setPathAnswers] = useState([]);
    const [finalCareer, setFinalCareer] = useState(null);
    const [fieldIndex, setFieldIndex] = useState(0);

    useEffect(() => {
        fetch('questions.json')
            .then(response => response.json())
            .then(data => setQuestions(data))
            .catch(error => console.error('Error loading questions:', error));

        fetch('statistics.json')
            .then(response => response.json())
            .then(data => setStatistics(data))
            .catch(error => console.error('Error loading statistics:', error));
    }, []);

    const startQuiz = () => {
        setShowTitleScreen(false);
    };

    const handleAnswer = (answerText) => {
        if (!fieldPath && !showFieldResult) {
            const updatedAnswers = [...answers, answerText];
            setAnswers(updatedAnswers);

            if (currentQuestionIndex + 1 < questions.length) {
                setCurrentQuestionIndex(currentQuestionIndex + 1);
            } else {
                const rankedFields = CalculateFields(updatedAnswers, questions);
                setFieldPathOptions(rankedFields);
                setFieldPath(rankedFields[fieldIndex]);
                setShowFieldResult(true);
            }
        } else if (!showFieldResult) {
            const currentQ = pathQuestions[pathAnswers.length];
            const questionText = Object.keys(currentQ)[0];
            const selectedValue = Object.entries(currentQ[questionText]).find(([text]) => text === answerText);

            if (selectedValue && selectedValue[1]) {
                const result = selectedValue[1];
                const nextQuestion = pathQuestions.find(q => Object.keys(q)[0] === result);

                if (nextQuestion) {
                    const updatedQuestions = [...pathQuestions.slice(0, pathAnswers.length + 1), nextQuestion];
                    setPathQuestions(updatedQuestions);
                    setPathAnswers([...pathAnswers, answerText]);
                } else {
                    setPathAnswers([...pathAnswers, answerText]);
                    setFinalCareer(result);
                }
            }
        }
    };

    const handleBack = () => {
        if (!fieldPath && !showFieldResult) {
            if (answers.length > 0) {
                const newAnswers = [...answers];
                newAnswers.pop();
                setAnswers(newAnswers);
                setCurrentQuestionIndex(prev => prev - 1);
            }
        } else if (!showFieldResult && pathAnswers.length > 0) {
            const newAnswers = [...pathAnswers];
            newAnswers.pop();
            const newQuestions = pathQuestions.slice(0, newAnswers.length + 1);
            setPathAnswers(newAnswers);
            setPathQuestions(newQuestions);
        }
    };

    const continueToPathQuestions = () => {
        setShowFieldResult(false);
        fetch(`paths/${fieldPath.toUpperCase()}_PATH.json`)
            .then(response => response.json())
            .then(data => {
                const firstQuestion = data[0];
                setPathQuestions([firstQuestion, ...data.slice(1)]);
            })
            .catch(error => console.error('Error loading path questions:', error));
    };

    const tryNextBestField = () => {
        const nextIndex = fieldIndex + 1;
        if (nextIndex < fieldPathOptions.length) {
            setFieldIndex(nextIndex);
            setFieldPath(fieldPathOptions[nextIndex]);
        } else {
            alert("That's all the options we had based on your answers!");
        }
    };

    if (showTitleScreen) {
        return (
            <div className="App">
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '20px',
                        textAlign: 'center',
                        maxWidth: '100%',
                        overflow: 'hidden'
                    }}
                >
                    <img
                        src={`/images/opening_L.png`}
                        alt="left decoration"
                        style={{height: '300px', width: 'auto'}}
                    />
                    <h2>
                        Building a Bridge to the Future You!
                    </h2>
                    <img
                        src={`/images/opening_R.png`}
                        alt="right decoration"
                        style={{height: '300px', width: 'auto'}}
                    />
                    <p style={{fontsize: '24'}}>
                        In this fun and interactive quiz, you'll embark on an exciting journey to explore your unique
                        talents, interests, and passions in STEAM (Science, Technology, Engineering, Arts, and Math).
                        Just
                        like constructing a bridge piece by piece, you'll answer creative questions that reveal the
                        building
                        blocks of your future career and personal growth. Get ready to discover hidden strengths,
                        uncover
                        new possibilities, and build a roadmap toward the amazing future that's uniquely yours!
                    </p>
                </div>
                <SupportedCareers/>
                <button onClick={startQuiz}>Start Quiz</button>
            </div>
        );
    }

    if (showFieldResult) {
        return (
            <div className="App">
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '20px',
                        textAlign: 'center',
                        maxWidth: '100%',
                        overflow: 'hidden'
                    }}
                >
                    <img
                        src={`/images/${fieldPath}_L.png`}
                        alt="right decoration"
                        style={{height: '175px', width: 'auto'}}
                    />
                    <p style ={{fontSize: '42px'}}>Your recommended field is: <strong>{fieldPath}</strong></p>
                    <img
                        src={`/images/${fieldPath}_R.png`}
                        alt="right decoration"
                        style={{height: '175px', width: 'auto'}}
                    />
                </div>
                <button onClick={continueToPathQuestions}>Continue</button>
                <button onClick={tryNextBestField}>Think we got it wrong? Try your next best!</button>
            </div>
        );
    }

    if (finalCareer) {
        const stats = statistics[finalCareer];

        return (
            <div className="App">
                <h1>Your Suggested Career Path:</h1>

                {/* Flexbox row with images and career name */}
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '20px',
                        textAlign: 'center',
                        maxWidth: '100%',
                        overflow: 'hidden'
                    }}
                >
                    <img
                        src={`/images/${finalCareer.replace(/[<>:"/\\|?*]/g, '')}_L-removebg-preview.png`}
                        alt="left decoration"
                        style={{height: '400px', width: 'auto'}}
                    />

                    <div style={{flex: '0 1 auto'}}>
                        <h2
                            style={{
                                margin: 0,
                                fontSize: '52px',
                                lineHeight: '1.1',
                                wordBreak: 'break-word',
                                maxWidth: '100%',
                                overflowWrap: 'break-word',
                                flex: '1 1 100%',
                                textAlign: 'center'
                            }}
                        >
                            {finalCareer}
                        </h2>
                    </div>

                    <img
                        src={`/images/${finalCareer.replace(/[<>:"/\\|?*]/g, '')}_R-removebg-preview.png`}
                        alt="right decoration"
                        style={{height: '400px', width: 'auto'}}
                    />
                </div>


                {stats ? (
                    <div style={{marginTop: '1.5em', textAlign: 'center'}}>
                        <p><strong>Median Salary:</strong> {stats.median_salary}</p>
                        <p><strong>Top 3 Schools:</strong> {stats.top_3_schools.join(', ')}</p>
                        <p><small>Source: {stats.source} ({stats.year_obtained})</small></p>
                    </div>
                ) : (
                    <p>No stats found for this career.</p>
                )}

                <a
                    href={`https://docs.google.com/forms/d/e/1FAIpQLSeqbeVAlMKzPjObs370as4-XDBdERgWElIP6U_FBdffqCc_rg/viewform?usp=dialog`}
                    style={{
                        display: 'inline-block',
                        marginTop: '1.5em',
                        color: '#fff',
                        backgroundColor: '#d63384',
                        padding: '10px 20px',
                        borderRadius: '6px',
                        textDecoration: 'none'
                    }}
                >
                    Have any feedback for us to improve your experience? Take this survey!
                </a>
                <br />
                <a
                    href={`/games/${ReplaceForURL(finalCareer)}`}
                    style={{
                        display: 'inline-block',
                        marginTop: '1.5em',
                        color: '#fff',
                        backgroundColor: '#d63384',
                        padding: '10px 20px',
                        borderRadius: '6px',
                        textDecoration: 'none'
                    }}
                >
                    Want to play the game associated with this field?
                </a>

            </div>
        );
    }


    const isPathStage = fieldPathOptions !== null && pathQuestions.length > 0;
    const questionList = isPathStage ? pathQuestions : questions;
    const currentIndex = isPathStage ? pathAnswers.length : currentQuestionIndex;
    const currentQuestion = questionList[currentIndex];

    if (!currentQuestion) return <div className="App"><p>Loading...</p></div>;

    const questionText = Object.keys(currentQuestion)[0];
    const options = Object.entries(currentQuestion[questionText]);

    return (
        <div className="App">

            <div className="quiz">
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '5px'
                }}>
                    {currentIndex > 0 && (
                        <button
                            style={{
                                backgroundColor: 'pink',
                                color: 'black',
                                padding: '6px 12px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                            onClick={handleBack}
                        >
                            ⬅ Back
                        </button>
                    )}
                    <h1 style={{ margin: '0 auto' }}>{questionText}</h1>
                </div>
                <div className="options-container">
                    {options.map(([optionText, _], index) => (
                        <button key={index} onClick={() => handleAnswer(optionText)}>
                            {optionText}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    )};

export default App;


